import { render, staticRenderFns } from "./RegisteredPanel.vue?vue&type=template&id=2523b99c&scoped=true"
import script from "./RegisteredPanel.vue?vue&type=script&lang=js"
export * from "./RegisteredPanel.vue?vue&type=script&lang=js"
import style0 from "./RegisteredPanel.vue?vue&type=style&index=0&id=2523b99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523b99c",
  null
  
)

export default component.exports